import { useRouter } from "next/router";
import { useWindowSize } from "../../../hooks/useWindowSize";
import styles from "./heroBlog.module.scss";

const HeroBlog = ({ allPosts }) => {
	const router = useRouter();

	const category = router.query.category;

	const blogOne = allPosts[0];
	const blogTwo = allPosts[1];
	const blogThree = allPosts[2];

	const blogFour = useWindowSize().width > 1199 ? allPosts[3] : allPosts[2];
	const blogFive = useWindowSize().width > 1199 ? allPosts[4] : allPosts[3];

	const filterData = [
		// {
		// 	name: "Fashion",
		// },
		// {
		// 	name: "Culture",
		// },
		// {
		// 	name: "Entertainment",
		// },
		// {
		// 	name: "Beauty",
		// },
		// {
		// 	name: "Life",
		// },
		// {
		// 	name: "Video",
		// },
	];

	return (
		<section className={styles.blog__hero}>
			<div className={styles.blog__hero__filter}>
				{/* <ul>
					{filterData.map((item, index) => (
						<a
							href={{
								pathname: "blog",
								query: { category: item.name.toLowerCase() },
							}}
						>
							<a>
								<li
									className={`${styles.list__item} ${
										category &&
										category === item.name.toLowerCase() &&
										styles.active
									}`}
									key={index}
								>
									{item.name}
								</li>
							</a>
						</a>
					))}
				</ul> */}
			</div>
			{allPosts.length > 0 ? (
				<div className={styles.blog__hero__blogs}>
					<div className={styles.blog__hero__blogs__left}>
						{blogOne && (
							<div className={styles.blog__hero__blogs__left__top__blog}>
								<div
									className={styles.blog__hero__blogs__left__top__blog__content}
								>
									<div className={styles.top__content}>
										<a
											href={
												blogOne?.category
													? `/blog/${blogOne?.category}/${blogOne.slug}`
													: `/blog/${blogOne.slug}`
											}
										>
											<a>
												<h2>{blogOne.title}</h2>
											</a>
										</a>
										<p>{blogOne.excerpt}</p>
									</div>

									<a
										href={
											blogOne?.category
												? `/blog/${blogOne?.category}/${blogOne.slug}`
												: `/blog/${blogOne.slug}`
										}
									>
										<a>
											<img
												src={blogOne.coverImage}
												className={styles.postCover}
											/>
										</a>
									</a>
								</div>
							</div>
						)}

						{blogTwo && (
							<div className={styles.blog__hero__blogs__left__bottom__blog}>
								<div
									className={styles.blog__hero__blogs__left__top__blog__content}
								>
									<div className={styles.top__content}>
										<a
											href={
												blogTwo?.category
													? `/blog/${blogTwo?.category}/${blogTwo.slug}`
													: `/blog/${blogTwo.slug}`
											}
										>
											<a>
												<h2>{blogTwo.title}</h2>
											</a>
										</a>

										<p>{blogTwo.excerpt}</p>
									</div>

									<a
										href={
											blogTwo?.category
												? `/blog/${blogTwo?.category}/${blogTwo.slug}`
												: `/blog/${blogTwo.slug}`
										}
									>
										<a>
											<img
												src={blogTwo.coverImage}
												className={styles.postCover}
											/>
										</a>
									</a>

									<div className={styles.btn}>
										<a
											href={
												blogTwo?.category
													? `/blog/${blogTwo?.category}/${blogTwo.slug}`
													: `/blog/${blogTwo.slug}`
											}
										>
											<a>
												<button className={styles.button}>
													Continue Reading
												</button>
											</a>
										</a>
									</div>
								</div>
							</div>
						)}
					</div>
					<div className={styles.blog__hero__blogs__right}>
						{blogThree && (
							<div className={styles.blog__hero__blogs__right__top}>
								<div
									className={styles.blog__hero__blogs__left__top__blog__content}
								>
									<div className={styles.top__content}>
										<a
											href={
												blogThree?.category
													? `/blog/${blogThree?.category}/${blogThree.slug}`
													: `/blog/${blogThree.slug}`
											}
										>
											<a>
												<h2>{blogThree.title}</h2>
											</a>
										</a>

										<p>{blogThree.excerpt}</p>
									</div>

									<a
										href={
											blogThree?.category
												? `/blog/${blogThree?.category}/${blogThree.slug}`
												: `/blog/${blogThree.slug}`
										}
									>
										<a>
											<img
												src={blogThree.coverImage}
												className={styles.postCover}
											/>
										</a>
									</a>

									<div className={styles.btn}>
										<a
											href={
												blogThree?.category
													? `/blog/${blogThree?.category}/${blogThree.slug}`
													: `/blog/${blogThree.slug}`
											}
										>
											<a>
												<button className={styles.button}>
													Continue Reading
												</button>
											</a>
										</a>
									</div>
								</div>
							</div>
						)}

						<div className={styles.blog__hero__blogs__right__bottom}>
							{blogFour && (
								<div className={styles.blog__hero__blogs__right__bottom__left}>
									<div
										className={
											styles.blog__hero__blogs__left__top__blog__content
										}
									>
										<div className={styles.top__content}>
											<a
												href={
													blogFour?.category
														? `/blog/${blogFour?.category}/${blogFour.slug}`
														: `/blog/${blogFour.slug}`
												}
											>
												<a>
													<h2>{blogFour.title}</h2>
												</a>
											</a>

											<p>{blogFour.excerpt}</p>
										</div>

										<a
											href={
												blogFour?.category
													? `/blog/${blogFour?.category}/${blogFour.slug}`
													: `/blog/${blogFour.slug}`
											}
										>
											<a>
												<img
													src={blogFour.coverImage}
													width='auto'
													height='303px'
													className={styles.postCover}
												/>
											</a>
										</a>

										<div className={styles.btn}>
											<a
												href={
													blogFour?.category
														? `/blog/${blogFour?.category}/${blogFour.slug}`
														: `/blog/${blogFour.slug}`
												}
											>
												<a>
													<button className={styles.button}>
														Continue Reading
													</button>
												</a>
											</a>
										</div>
									</div>
								</div>
							)}
							<div className={styles.blog__hero__blogs__right__bottom__right}>
								{blogFive && (
									<div
										className={
											styles.blog__hero__blogs__left__top__blog__content
										}
									>
										<div className={styles.top__content}>
											<a
												href={
													blogFive?.category
														? `/blog/${blogFive?.category}/${blogFive.slug}`
														: `/blog/${blogFive.slug}`
												}
											>
												<a>
													<h2>{blogFive.title}</h2>
												</a>
											</a>

											<p>{blogFive.excerpt}</p>
										</div>

										<a
											href={
												blogFive?.category
													? `/blog/${blogFive?.category}/${blogFive.slug}`
													: `/blog/${blogFive.slug}`
											}
										>
											<a>
												<img
													src={blogFive.coverImage}
													width='auto'
													height='303px'
													className={styles.postCover}
												/>
											</a>
										</a>

										<div className={styles.btn}>
											<a
												href={
													blogFive?.category
														? `/blog/${blogFive?.category}/${blogFive.slug}`
														: `/blog/${blogFive.slug}`
												}
											>
												<a>
													<button className={styles.button}>
														Continue Reading
													</button>
												</a>
											</a>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			) : (
				<h2 className={styles.not__found}>No Blogs Found</h2>
			)}
		</section>
	);
};

export default HeroBlog;
